import { render } from "./Deduct.vue?vue&type=template&id=328d959b&scoped=true"
import script from "./Deduct.vue?vue&type=script&lang=js"
export * from "./Deduct.vue?vue&type=script&lang=js"

import "./Deduct.vue?vue&type=style&index=0&id=328d959b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328d959b"],['__file',"src/views/qywx/crm/kpi/Deduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "328d959b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('328d959b', __exports__)) {
    api.reload('328d959b', __exports__)
  }
  
  module.hot.accept("./Deduct.vue?vue&type=template&id=328d959b&scoped=true", () => {
    api.rerender('328d959b', render)
  })

}


export default __exports__